import { logicalWidth, logicalHeight, canvas } from "./setup.js";
import { state } from "./state.js";
import { screen } from "./screen.js";
import { cellWidth, cellHeight, ctx, rows, columns } from "./setup.js";

// Render the complete screen.
export const renderScreen = () => {
  // Clear the canvas.
  ctx.clearRect(0, 0, logicalWidth, logicalHeight);
  // Get the lines from state.
  let lines = screen.lines;

  // Render all lines.
  for (let i = 0; i < lines.length; i++) {
    renderLine(i, lines[i]);
  }
  // Draw the blinking cursor at the cursor position.
  if (state.showCursor && !state.blockCursor) {
    const cursorRow = screen.cursorPosition[0];
    const cursorCol = screen.cursorPosition[1];

    // At the position of the cursor, the cell is drawn with inverted colors.
    var cell = lines[cursorRow][cursorCol];
    if (cell) {
      ctx.fillStyle = cell.fg;
      ctx.fillRect(cursorCol * cellWidth, cursorRow * cellHeight, cellWidth, cellHeight);
      ctx.fillStyle = cell.bg;
      ctx.fillText(cell.char, cursorCol * cellWidth, cursorRow * cellHeight);
    }
  }
};

// Scale the canvas's CSS dimensions to scale up neatly.
export const resizeCanvas = () => {
  const scaleX = window.innerWidth / logicalWidth;
  const scaleY = window.innerHeight / logicalHeight;
  const scale = Math.floor(Math.min(scaleX, scaleY));
  canvas.style.width = logicalWidth * scale + "px";
  canvas.style.height = logicalHeight * scale + "px";
};

// Render a single line at the given row index.
const renderLine = (row, cells) => {
  for (let i = 0; i < cells.length && i < columns; i++) {
    const cell = cells[i];

    // Draw the cell background.
    ctx.fillStyle = cell.bg;
    ctx.fillRect(i * cellWidth, row * cellHeight, cellWidth, cellHeight);

    // Draw the character in the foreground color.
    ctx.fillStyle = cell.fg;
    ctx.fillText(cell.char, i * cellWidth, row * cellHeight);
  }
};